export default __webpack_public_path__ + "43016064f1d86a4d1b0bcfa24f8e344f.svg";